<div class="container-fluid">
  <app-custom-table-title [icon]="icon" [title]="title" [subTitle]="subTitle"></app-custom-table-title>
  <div class="mt-4 mb-4 cf-table-card">
    <ng-template #quickFilter>
      <div class="quick-filter">
        <app-search-filter [value]="quickSearch" placeholder="Buscar tarjeta..." (searchChange)="onSearchChange($event)"></app-search-filter>
      </div>
    </ng-template>

    <app-custom-table #table="customTable" [config]="tableConfig"></app-custom-table>
  </div>
</div>
